export { default as history } from './history';
export const capatalise = str => str[0].toUpperCase() + str.slice(1);
//export { navigateTo, navigateBack, navigateForward } from './connectedRouter';

export const severityMapping={
    0:'Cleared',
    1:'Indeterminate',
    2:'Warning',
    3:'Minor',
    4:'Major',
    5:'Critical',
    7:'Cleared'
  }
